<template>
  <div style="box-sizing: border-box; padding: 10px 20px 0; min-width: 1080px">
    <div class="merchandise-container">
      <div class="head">会员分组</div>
      <div class="content">
        <input-form
          ref="inputForm"
          :btnPosition="true"
          style="margin-left: -45px"
          :inputData="inputData"
          :pageName="pageName"
          @toParentVal="searchContent"
        ></input-form>

        <div class="table-wrapper">
          <div class="tabList">
            <span :class="{ active: tabActiveIndex == 1 }" @click="handleClick0"
              >全部分组</span
            >
            <span :class="{ active: tabActiveIndex == 2 }" @click="handleClick"
              >系统分组</span
            >
            <span :class="{ active: tabActiveIndex == 3 }" @click="handleClick2"
              >我的分组</span
            >
            <i></i>
          </div>
          <el-button
            class="btn"
            @click="creationGrouping"
            v-zoom="{ from: pageName, name: '创建分组' }"
            style="margin: 10px 0"
          >
            <img
              src="@/assets/images/member/new_establish.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin-right: 3px;
              "
            />创建分组
          </el-button>

          <!-- 创建分组弹窗 -->
          <el-dialog
            :title="title"
            :visible.sync="dialogFormCreate"
            width="1020px"
          >
            <el-form
              ref="ruleForm"
              :model="ruleForm"
              :rules="rules"
              label-width="100px"
            >
              <el-form-item label="分组名称:" prop="groupName">
                <el-input
                  v-model="ruleForm.groupName"
                  :disabled="disabled"
                ></el-input>
              </el-form-item>

              <el-form-item label="分组说明:" prop="instruction">
                <el-input
                  v-model="ruleForm.instruction"
                  :disabled="disabled"
                ></el-input>
              </el-form-item>

              <el-form-item label="选择标签：">
                <div class="box" @click="toAddLabelMoreResult">
                  <ul>
                    <li v-for="(item, index) in selectIdsArr" :key="index">
                      {{ item.labelName }}
                      <div
                        class="el-icon-close"
                        @click="deleteLabel(item)"
                      ></div>
                    </li>
                  </ul>
                  <div class="el-icon-arrow-down jiantou"></div>
                </div>
              </el-form-item>

              <el-form-item label="指定SKU:" prop="skuIds">
                <el-input v-model="ruleForm.whereJson.skuIds"></el-input>
              </el-form-item>

              <el-form-item label="交易总额:">
                <el-radio-group
                  @change="
                    (val) => {
                      changeType(val, 0);
                    }
                  "
                  v-model="ruleForm.whereJson.totalPayment"
                >
                  <el-radio
                    v-for="(item, index) in totalPaymentList"
                    :key="index"
                    :label="item.value"
                  >
                    {{ item.label }}
                    <div
                      v-if="item.value == '-1'"
                      style="display: inline-block"
                    >
                      <el-input
                        placeholder="请输入..."
                        :disabled="!(ruleForm.whereJson.totalPayment == '-1')"
                        v-model="ruleForm.whereJson.starttotalPayment"
                        onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                        style="width: 90px; margin-left: 8px"
                      ></el-input>
                      <span class="to" style="margin: 0 8px">至</span>
                      <el-input
                        placeholder="请输入..."
                        :disabled="!(ruleForm.whereJson.totalPayment == '-1')"
                        v-model="ruleForm.whereJson.endtotalPayment"
                        onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                        style="width: 90px"
                      ></el-input>
                      <span class="company" style="margin-left: 8px">元</span>
                    </div>
                  </el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="网购次数:">
                <el-radio-group
                  @change="
                    (val) => {
                      changeType(val, 1);
                    }
                  "
                  v-model="ruleForm.whereJson.orderCount"
                >
                  <el-radio label="">不限</el-radio>
                  <el-radio :label="0">0次</el-radio>
                  <el-radio :label="1">1次</el-radio>
                  <el-radio :label="2">2次</el-radio>
                  <el-radio :label="3">3次以上</el-radio>
                  <el-radio :label="-1"
                    >自定义
                    <el-input
                      placeholder="请输入..."
                      :disabled="!(ruleForm.whereJson.orderCount == '-1')"
                      v-model="ruleForm.whereJson.startorderCount"
                      onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                      style="width: 100px; margin-left: 8px"
                    ></el-input>
                    <span class="to" style="margin: 0 8px">至</span>
                    <el-input
                      placeholder="请输入..."
                      :disabled="!(ruleForm.whereJson.orderCount == '-1')"
                      v-model="ruleForm.whereJson.endorderCount"
                      onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                      style="width: 100px"
                    ></el-input>
                    <span class="company" style="margin-left: 8px">次</span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="平均客单价:">
                <el-radio-group
                  @change="
                    (val) => {
                      changeType(val, 2);
                    }
                  "
                  v-model="ruleForm.whereJson.averagePricement"
                >
                  <el-radio
                    v-for="(item, index) in totalPaymentList"
                    :key="index"
                    :label="item.value"
                  >
                    {{ item.label }}
                    <div
                      v-if="item.value == '-1'"
                      style="display: inline-block"
                    >
                      <el-input
                        onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                        placeholder="请输入..."
                        :disabled="
                          !(ruleForm.whereJson.averagePricement == '-1')
                        "
                        v-model="ruleForm.whereJson.startaveragePricement"
                        style="width: 85px; margin-left: 8px"
                      ></el-input>
                      <span class="to" style="margin: 0 8px">至</span>
                      <el-input
                        placeholder="请输入..."
                        onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                        :disabled="
                          !(ruleForm.whereJson.averagePricement == '-1')
                        "
                        v-model="ruleForm.whereJson.endtotaveragePricement"
                        style="width: 85px"
                      ></el-input>
                      <span class="company" style="margin-left: 8px">元</span>
                    </div>
                  </el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="会员等级:">
                <el-checkbox v-model="levelUnlimited" @change="switchLevel('0')"
                  >不限</el-checkbox
                >
                <el-checkbox-group
                  v-model="gradeMembershipArr"
                  @change="switchLevel('1')"
                  style="display: inline-block; margin-left: 20px"
                >
                  <!-- <el-checkbox
                    v-for="(item, index) in gradesList"
                    :label="item.value"
                    :key="index"
                  >
                    {{ item.label }}
                  </el-checkbox> -->
                  <el-checkbox label="1">一星会员</el-checkbox>
                  <el-checkbox label="2">二星会员</el-checkbox>
                  <el-checkbox label="3">三星会员</el-checkbox>
                  <el-checkbox label="4">四星会员</el-checkbox>
                  <el-checkbox label="5">五星会员</el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="最后交易时间:">
                <el-radio-group
                  @change="
                    (val) => {
                      changeType(val, 3);
                    }
                  "
                  v-model="ruleForm.whereJson.orderTime"
                >
                  <el-radio label="">不限</el-radio>
                  <el-radio label="week">近7天</el-radio>
                  <el-radio label="oneMonth">近一个月</el-radio>
                  <el-radio label="threeMonth">近三个月</el-radio>
                  <el-radio label="sixMonth">近半年</el-radio>
                  <el-radio label="Customized"
                    >自定义
                    <el-date-picker
                      :disabled="ruleForm.whereJson.orderTime != 'Customized'"
                      type="date"
                      placeholder="选择日期时间"
                      :picker-options="pickerOptions0"
                      size="small"
                      style="width: 130px; margin-left: 8px"
                      value-format="yyyy-MM-dd"
                      v-model="ruleForm.whereJson.startorderTime"
                    >
                    </el-date-picker>
                    <span class="to" style="margin: 0 8px">至</span>
                    <el-date-picker
                      :disabled="ruleForm.whereJson.orderTime != 'Customized'"
                      type="date"
                      placeholder="选择日期时间"
                      :picker-options="pickerOptions1"
                      size="small"
                      style="width: 130px"
                      value-format="yyyy-MM-dd"
                      v-model="ruleForm.whereJson.endorderTime"
                    >
                    </el-date-picker>
                    <span class="company" style="margin-left: 8px">天</span>
                  </el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="所在地区:">
                <el-radio-group v-model="ruleForm.whereJson.area">
                  <el-radio label @change="cityRadioChange('')">不限</el-radio>
                  <el-tooltip
                    content="江苏省、浙江省、上海"
                    placement="bottom"
                    effect="light"
                  >
                    <el-radio label="JZH" @change="cityRadioChange('JZH')"
                      >江浙沪</el-radio
                    >
                  </el-tooltip>
                  <el-tooltip
                    content="新疆、西藏、云南省、青海省"
                    placement="bottom"
                    effect="light"
                  >
                    <el-radio
                      label="RemoteArea"
                      @change="cityRadioChange('RemoteArea')"
                      >偏远地区</el-radio
                    >
                  </el-tooltip>
                  <el-radio
                    label="Customized"
                    @click.stop.native="changeCityShow"
                    @change="cityRadioChange('Customized')"
                    >自定义</el-radio
                  >
                </el-radio-group>
                <el-button
                  style="margin-left: 12px"
                  type="danger"
                  @click="changeCityShow"
                  v-if="ruleForm.whereJson.area == 'Customized'"
                  plain
                  >已选择{{ checkedList.length }}个</el-button
                >
                <el-button
                  slot="reference"
                  size="small"
                  class="goods-button button-status3"
                  v-if="ruleForm.whereJson.area.length == 0"
                  :style="{ 'margin-left': '26px' }"
                  @click="changeCityShow"
                  >已选{{ checkedList.length }}个</el-button
                >
              </el-form-item>

              <div style="margin-left: 160px; margin-top: 5px">
                <city-popover
                  v-model="cityShow"
                  :checkedList="checkedList"
                  @on-change="getLocation"
                ></city-popover>
              </div>

              <el-form-item label="职业:">
                <el-checkbox-group v-model="crowd_portrait_typeArr">
                  <el-checkbox
                    v-for="(item, index) in worker_all"
                    :label="item.label"
                    :key="index"
                  >
                    {{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item size="large" style="text-align: center" label-width="0">
                <el-button
                  type="primary"
                  style="margin: 0 auto"
                  v-loading="createLoading"
                  @click.native="onSubmit('ruleForm')"
                  v-if="btnnumber == 1"
                  >立即创建</el-button
                >
                <el-button
                  v-if="btnnumber == 2"
                  type="primary"
                  style="margin: 0 auto"
                  v-loading="createLoading"
                  @click.native="ImmediatelyChange()"
                  >修改分组</el-button
                >
              </el-form-item>
            </el-form>
          </el-dialog>

          <el-table
            :data="tableList"
            v-loading="tableLoading"
            highlight-current-row
            style="width: 100%"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="sid" label="序号" width="80">
              <template slot-scope="scope">
                <span v-text="getIndex(scope.$index)"></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="groupName"
              label="分组名称"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="buyerNum"
              label="客户数（人）"
            ></el-table-column>
            <el-table-column label="分组来源">
              <template slot-scope="scope">
                <span>{{ scope.row.type == 0 ? "我的分组" : "系统分组" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="instruction" label="说明"></el-table-column>

            <el-table-column label="创建时间">
              <template slot-scope="scope">
                {{ scope.row.crtime }}
              </template>
              <!-- <template slot-scope="scope"> --- </template> -->
            </el-table-column>

            <el-table-column label="操作" width="230px">
              <template slot-scope="scope">
                <!-- <el-button
                  type="text"
                  @click="handleDelete1(scope.row.id)"
                  style="color: #fe4d45; width: 60px"
                  v-if="scope.row.type !== 1"
                  >删除分组</el-button
                > -->
                <div class="titlecolorBox">
                  <span
                    v-if="scope.row.type == 1"
                    style="color: #ddd; margin-right: 20px"
                    >删除分组</span
                  >
                  <span
                    v-if="scope.row.type == 1"
                    style="color: #ddd; margin-right: 20px"
                    >修改分组</span
                  >
                  <span
                    @click="handleDelete1(scope.row.id)"
                    v-zoom="{ from: pageName, name: '删除分组' }"
                    v-if="scope.row.type !== 1"
                    class="titlecolor"
                    style="margin-right: 20px"
                    >删除分组</span
                  >
                  <span
                    @click="reviseGroup(scope.$index, scope.row)"
                    v-zoom="{ from: pageName, name: '修改分组' }"
                    v-if="scope.row.type !== 1"
                    class="titlecolor1"
                    style="margin-right: 20px"
                    >修改分组</span
                  >
                  <span
                    @click="marketNow(scope.$index, tableList, scope.row)"
                    v-zoom="{ from: pageName, name: '会员营销' }"
                    class="titlecolor"
                    >会员营销</span
                  >
                </div>
                <!-- <el-button type="text" style="width: 60px" v-else></el-button> -->
                <!-- <el-button
                  type="text"
                  @click="reviseGroup(scope.$index, scope.row)"
                  style="color: #7f85e9; width: 60px"
                  v-if="scope.row.type !== 1"
                  >修改分组</el-button
                >
                <el-button type="text" style="width: 60px" v-else></el-button> -->
                <!-- <el-button
                  type="text"
                  @click.native.prevent="
                    marketNow(scope.$index, tableList, scope.row)
                  "
                  style="color: #7f85e9; width: 60px"
                  >会员营销</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            style="text-align: right; margin-top: 20px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="formDataList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            :current-page="formDataList.current"
          ></el-pagination>

          <!-- 选择标签 -->
          <select-label
            :labelState="labelState"
            :selectIdsArr="selectIdsArr2"
            @transferName4="transferName4"
          ></select-label>
        </div>
      </div>
    </div>
    <!-- 删除弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisible"
      width="400px"
      :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px"
        >确定要删除吗?</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getShopBuyerGroup,
  deleteBuyerGroupById,
  createBuyerGroup,
  reviseBuyerGroup,
} from "@/api/shopBuyerGroup";
import { getBuyerLabel } from "@/api/buyerLabel.js";

import inputForm from "../../components/inputForm";
import cityPopover from "@/components/city-popover-x.vue";
import selectLabel from "@/components/select-label.vue";

export default {
  name: "evaluate_polite",
  components: {
    cityPopover,
    selectLabel,
    inputForm,
  },

  data() {
    return {
      disabled: false,
      btnnumber: 1,
      // pageName:"",
      title: "创建分组",
      levelUnlimited: true, // 会员等级， 不限制
      tableLoading: true,
      tabActiveIndex: 1,
      activeName: "first", //标签页页头
      startTime: null,
      endTime: null,
      // serialNum: "", //序号
      //表单数据
      formDataList: {
        size: 10,
        current: 1,
        id: "", //标签id
        type: "",
      },
      inputData: [
        {
          name: "创建时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault:true,
        },
      ],
      worker_all: [
        {
          name: "学生",
          label: "1",
        },
        {
          name: "白领",
          label: "2",
        },
        {
          name: "公务员",
          label: "3",
        },
        {
          name: "IT",
          label: "4",
        },
        {
          name: "金融",
          label: "5",
        },
        {
          name: "居家",
          label: "6",
        },
        {
          name: "医护",
          label: "7",
        },
        {
          name: "其他",
          label: "8",
        },
      ],
      totalPaymentList: [
        {
          label: "不限",
          value: "",
        },
        {
          label: "0-100",
          value: "OneAndHundred",
        },
        {
          label: "100-200",
          value: "HundredAndTwoHundred",
        },
        {
          label: "200-300",
          value: "TwoHundredAndThreeHundred",
        },
        {
          label: "300以上",
          value: "ThreeHundredTheAbove",
        },
        {
          label: "自定义",
          value: "-1",
        },
      ],
      addResult: false,
      dialogFormCreate: false,
      checkedList: [],
      crowd_portrait_typeArr: [],

      gradeMembershipArr: [],
      //弹窗数据
      ruleForm: {
        id: "",
        groupName: "", //分组名称
        instruction: "", //分组说明
        whereJson: {
          area: "", //所在地区
          areaProvinces: "", //详细地区
          cites: "",
          averagePricement: "", //平均客单价
          startaveragePricement: "",
          endtotaveragePricement: "",
          crowd_portrait_type: "", //职业
          gradeMembership: "", //会员等级：
          labelIds: [], //标签ID
          orderCount: "", //网购次数
          startorderCount: "",
          endorderCount: "",
          startorderTime: "", //最后交易时间
          endorderTime: "",
          orderTime: "",
          skuIds: "", //指定SKU
          totalPayment: "", //交易总额
          starttotalPayment: "",
          endtotalPayment: "",
        },
      },
      handleDeleteid: "",
      outerVisible: false,
      ids: "",
      pickerOptions0: {
        disabledDate: (time) => {
          if (!this.ruleForm.whereJson.endorderTime) {
            return time.getTime() > Date.now();
          } else {
            let endTime = new Date(
              this.ruleForm.whereJson.endorderTime
            ).getTime();
            // 最小选择时间   (时间跨度不能大于一年时间)
            let minTime = endTime - 365 * 24 * 3600 * 1000;

            return (
              // time.getTime() < minTime || time.getTime() > Date.now() - 8.64e7
              time.getTime() > Date.now() - 8.64e7
            );
          }
        },
      },
      pickerOptions1: {
        disabledDate: (time) => {
          if (!this.ruleForm.whereJson.startorderTime) {
            return time.getTime() > Date.now() - 8.64e7;
          } else {
            let startTime = new Date(
              this.ruleForm.whereJson.startorderTime
            ).getTime();
            // 最大选择时间  （时间跨度不能大于一年）
            let maxTime = startTime + 365 * 24 * 3600 * 1000;

            return (
              time.getTime() < startTime ||
              time.getTime() > Date.now() - 8.64e7 ||
              time.getTime() > maxTime - 8.64e7
            );
          }
        },
      },
      //弹窗规则
      rules: {
        groupName: [
          { required: true, message: "分组名称不能为空", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
        instruction: [
          { message: "分组说明不能为空", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
      },
      tableList: [],
      totalNum: 0,
      cityShow: false,
      selectIdsArr2: [],
      labelState: false,
      labelIdsArr: [], //标签ID
      selectIdsArr: [], //标签名
      selectIdsList: {}, //所有标签
      createLoading: false,
    };
  },

  created(){
    // 调用埋点接口
    this.buriedPoint(1, '会员分组', '客户管理', '会员管理')
  },

  mounted() {
    this.$refs.inputForm.formSearch();
    // this.queryList();
    console.log(this.worker_all);
  },

  methods: {
    getLocation(val, state) {
      if (state == 'cancel') {
        return
      }
      this.checkedList = val;
    },
    searchForm() {},
    //获取表格序号
    getIndex($index) {
      //表格序号
      return (
        (this.formDataList.current - 1) * this.formDataList.size + $index + 1
      );
    },
    // 创建分组弹窗
    creationGrouping() {
      // console.log(this.pageName);
      this.btnnumber = 1;
      this.disabled = false;
      this.title = "创建分组";
      // 先清空列表
      this.checkedList = [];
      this.ruleForm.groupName = ""; //分组名称
      this.ruleForm.instruction = ""; //分组说明
      this.ruleForm.whereJson.area = ""; //所在地区
      this.ruleForm.whereJson.areaProvinces = ""; //详细地区
      this.ruleForm.whereJson.cites = ""; //详细地区
      this.ruleForm.whereJson.averagePricement = ""; //平均客单价
      this.ruleForm.whereJson.startaveragePricement = "";
      this.ruleForm.whereJson.endtotaveragePricement = "";
      this.levelUnlimited = true; //会员等级：
      this.gradeMembershipArr = []; //会员等级：
      this.selectIdsArr = []; //标签ID
      this.crowd_portrait_typeArr = [];
      this.ruleForm.whereJson.orderCount = ""; //网购次数
      this.ruleForm.whereJson.startorderCount = "";
      this.ruleForm.whereJson.endorderCount = "";
      this.ruleForm.whereJson.startorderTime = ""; //最后交易时间
      this.ruleForm.whereJson.endorderTime = "";
      this.ruleForm.whereJson.orderTime = "";
      this.ruleForm.whereJson.skuIds = ""; //指定SKU
      this.ruleForm.whereJson.totalPayment = ""; //交易总额
      this.ruleForm.whereJson.starttotalPayment = "";
      this.ruleForm.whereJson.endtotalPayment = "";
      this.selectIdsArr2 = [];
      this.dialogFormCreate = true; //开启弹窗
    },
    //创建分组
    onSubmit(ruleForm) {
      let status = this.rulesForm();
      if (status) {
        return;
      }
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.ruleForm.whereJson.crowd_portrait_type = this.crowd_portrait_typeArr.toString();
          this.ruleForm.whereJson.labelIds = this.labelIdsArr.toString();
          this.ruleForm.whereJson.gradeMembership = this.gradeMembershipArr.toString();
          // this.ruleForm.whereJson.areaProvinces = this.checkedList.join(',');
          this.ruleForm.whereJson.cites = this.checkedList.join(',');
          // console.log(this.ruleForm.whereJson.gradeMembership);
          if (this.ruleForm.whereJson.area == 'RemoteArea' || this.ruleForm.whereJson.area == 'JZH') {
            this.ruleForm.whereJson.cites = ''
          }
          this.createLoading = true;
          createBuyerGroup(this.ruleForm).then((res) => {
            this.createLoading = false;
            if (res.code == 0) {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
            if (res.code == 1) {
              this.$message({
                message: "创建成功",
                type: "success",
              });
              this.dialogFormCreate = false;
              this.ruleForm.groupName = ""; //分组名称
              this.ruleForm.instruction = ""; //分组说明
              this.ruleForm.whereJson.area = ""; //所在地区
              this.ruleForm.whereJson.areaProvinces = ""; //详细地区
              this.ruleForm.whereJson.cites = ""; //详细地区
              this.ruleForm.whereJson.averagePricemen = ""; //平均客单价
              this.ruleForm.whereJson.startaveragePricement = "";
              this.ruleForm.whereJson.endtotaveragePricement = "";
              this.ruleForm.whereJson.gradeMembership = ""; //会员等级：
              this.selectIdsArr = []; //标签ID
              this.ruleForm.whereJson.orderCount = ""; //网购次数
              this.ruleForm.whereJson.startorderCount = "";
              this.ruleForm.whereJson.endorderCount = "";
              this.ruleForm.whereJson.startorderTime = ""; //最后交易时间
              this.ruleForm.whereJson.endorderTime = "";
              this.ruleForm.whereJson.orderTime = "";
              this.ruleForm.whereJson.skuIds = ""; //指定SKU
              this.ruleForm.whereJson.totalPayment = ""; //交易总额
              this.ruleForm.whereJson.starttotalPayment = "";
              this.ruleForm.whereJson.endtotalPayment = "";
              this.queryList();
            }
          });
        }
        // else {
        //   console.log("error submit!!");
        //   this.$message.error("不能超过30个字符！");
        // }
      });
    },
    changeType(val, args) {
      // console.log(val,args);
      if (val != -1 && args == 0) {
        this.ruleForm.whereJson.starttotalPayment = "";
        this.ruleForm.whereJson.endtotalPayment = "";
        return;
      }
      if (val != -1 && args == 1) {
        this.ruleForm.whereJson.startorderCount = "";
        this.ruleForm.whereJson.endorderCount = "";
        return;
      }
      if (val != -1 && args == 2) {
        this.ruleForm.whereJson.startaveragePricement = "";
        this.ruleForm.whereJson.endtotaveragePricement = "";
        return;
      }
      if (val != "Customized" && args == 3) {
        this.ruleForm.whereJson.endorderTime = "";
        this.ruleForm.whereJson.startorderTime = "";
        return;
      }
    },
    rulesForm() {
      let start = [];
      let end = [];
      let status = false;
      if (this.ruleForm.whereJson.totalPayment == "-1") {
        if (
          this.ruleForm.whereJson.starttotalPayment + "" == "" &&
          this.ruleForm.whereJson.endtotalPayment + "" == ""
        ) {
          this.$message.warning("交易总额自定义数值不能为空");
          status = true;
          return status;
        }
      }
      if (this.ruleForm.whereJson.averagePricement == "-1") {
        if (
          this.ruleForm.whereJson.startaveragePricement + "" == "" &&
          this.ruleForm.whereJson.endtotaveragePricement + "" == ""
        ) {
          this.$message.warning("平均客单价自定义数值不能为空");
          status = true;

          return status;
        }
      }
      if (this.ruleForm.whereJson.averagePricemen == "-1") {
        if (
          this.ruleForm.whereJson.starttotalPayment + "" == "" &&
          this.ruleForm.whereJson.endtotalPayment + "" == ""
        ) {
          this.$message.warning("网购次数自定义数值不能为空");
          status = true;

          return status;
        }
      }
      // if (this.ruleForm.whereJson.orderTime == "Customized") {
      //   if (
      //     this.ruleForm.whereJson.startaveragePricement + "" == "" &&
      //     this.ruleForm.whereJson.endtotaveragePricement + "" == ""
      //   ) {
      //     this.$message.warning("网购次数自定义数值不能为空");
      //     status = true;
      //     return status;
      //   }
      // }

      for (let key in this.ruleForm.whereJson) {
        if (RegExp(/start/).test(key)) {
          start.push(this.ruleForm.whereJson[key]);
        }
        if (RegExp(/end/).test(key)) {
          end.push(this.ruleForm.whereJson[key]);
        }
      }
      start.forEach((i, index) => {
        if (start[index].indexOf("-") != -1) {
          return;
        }
        if (Number(start[index]) > Number(end[index])) {
          this.$message.error("自定义数值开始值不可大于结束值");
          status = true;
        }
      });
      return status;
    },
    //修改分组--确定按钮
    ImmediatelyChange() {
      // this.selectIdsArr2 = this.labelIdsArr;
      // console.log(this.ruleForm.whereJson);
      if (this.ruleForm.whereJson.totalPayment == "-1") {
        if (
          this.ruleForm.whereJson.starttotalPayment + "" == "" &&
          this.ruleForm.whereJson.endtotalPayment + "" == ""
        ) {
          this.$message.warning("交易总额自定义数值不能为空");
          return;
        }
      }
      if (this.ruleForm.whereJson.averagePricement == "-1") {
        if (
          this.ruleForm.whereJson.startorderCount + "" == "" &&
          this.ruleForm.whereJson.endorderCount + "" == ""
        ) {
          this.$message.warning("网购次数自定义数值不能为空");
          return;
        }
      }
      if (this.ruleForm.whereJson.averagePricemen == "-1") {
        if (
          this.ruleForm.whereJson.starttotalPayment + "" == "" &&
          this.ruleForm.whereJson.endtotalPayment + "" == ""
        ) {
          this.$message.warning("网购次数自定义数值不能为空");
          return;
        }
      }
      if (this.ruleForm.whereJson.orderTime == "Customized") {
        if (
          this.ruleForm.whereJson.startaveragePricement + "" == "" &&
          this.ruleForm.whereJson.endtotaveragePricement + "" == ""
        ) {
          this.$message.warning("网购次数自定义数值不能为空");
          return;
        }
      }
      let start = [];
      let end = [];
      let status = false;
      for (let key in this.ruleForm.whereJson) {
        if (RegExp(/start/).test(key)) {
          start.push(this.ruleForm.whereJson[key]);
        }
        if (RegExp(/end/).test(key)) {
          end.push(this.ruleForm.whereJson[key]);
        }
      }
      console.log(start, end);
      start.forEach((i, index) => {
        if (start[index].indexOf("-") != -1) {
          return;
        }
        if (+start[index] > +end[index]) {
          console.log(start[index] > end[index]);
          console.log('start[index]:', start[index])
          console.log('end[index]:', end[index])
          console.log(123);
          this.$message.error("自定义数值开始值不可大于结束值");
          status = true;
        }
      });
      if (status) {
        return;
      }
      this.ruleForm.whereJson.crowd_portrait_type = this.crowd_portrait_typeArr.toString();
      this.ruleForm.whereJson.labelIds = this.labelIdsArr.toString();
      this.ruleForm.whereJson.gradeMembership = this.gradeMembershipArr.toString();
      this.ruleForm.whereJson.orderCount = this.ruleForm.whereJson.orderCount.toString();
      this.ruleForm.id = this.ids;
      this.ruleForm.whereJson.cites = this.checkedList.join(',');
      if (this.ruleForm.whereJson.area == 'RemoteArea' || this.ruleForm.whereJson.area == 'JZH') {
        this.ruleForm.whereJson.cites = ''
      }
      console.log(this.selectIdsArr2, typeof this.selectIdsArr2);
      this.createLoading = true;
      reviseBuyerGroup(this.ruleForm)
        .then((res) => {
           this.createLoading = false;
          // console.log(res, "res");
          if (res.code == 0) {
            this.$message.error(res.message);
          }
          if (res.code == 1) {
            this.$message.success("修改成功");
            this.dialogFormCreate = false; //关闭弹窗
            this.queryList();
          }
        })
        .catch(() => {
          this.$message.error("修改失败");
        });
    },
    //修改分组-弹窗
    reviseGroup(index, form) {
      console.log(index, form);
      this.btnnumber = 2;
      this.title = "修改分组";
      this.ids = form.id;
      // this.selectIdsArr = []
      // console.log(form.id, "id");
      this.disabled = true; //分组名称禁止输入
      this.dialogFormCreate = true; //开启弹窗
      this.ruleForm.groupName = form.groupName; //分组名称
      this.ruleForm.instruction = form.instruction; //分组说明
      this.ruleForm.whereJson.skuIds = form.whereJsonDTO.skuIds; //指定SKU
      this.ruleForm.whereJson.totalPayment = form.whereJsonDTO.totalPayment; //交易总额
      if (form.whereJsonDTO.labelIds) {
        let arr = form.whereJsonDTO.labelIds.split(",");
        this.selectIdsArr2 = arr.map((i) => Number(i));
      } else this.selectIdsArr2 = [];
      if (form.whereJsonDTO.totalPayment == -1) {
        this.ruleForm.whereJson.starttotalPayment =
          form.whereJsonDTO.starttotalPayment;
        this.ruleForm.whereJson.endtotalPayment =
          form.whereJsonDTO.endtotalPayment;
      }
      //网购次数
      if (form.whereJsonDTO.orderCount == "") {
        this.ruleForm.whereJson.orderCount = "";
        this.ruleForm.whereJson.endorderCount = "";
        this.ruleForm.whereJson.startorderCount = "";
      } else if (form.whereJsonDTO.orderCount == -1) {
        this.ruleForm.whereJson.orderCount = -1;
        this.ruleForm.whereJson.endorderCount = form.whereJsonDTO.endorderCount;
        this.ruleForm.whereJson.startorderCount =
          form.whereJsonDTO.startorderCount;
      } else {
        this.ruleForm.whereJson.orderCount = Number(
          form.whereJsonDTO.orderCount
        );
        this.ruleForm.whereJson.endorderCount = "";
        this.ruleForm.whereJson.startorderCount = "";
      }
      this.ruleForm.whereJson.averagePricement =
        form.whereJsonDTO.averagePricement; //平均客单价

      if (form.whereJsonDTO.averagePricement == -1) {
        this.ruleForm.whereJson.startaveragePricement =
          form.whereJsonDTO.startaveragePricement;
        this.ruleForm.whereJson.endtotaveragePricement =
          form.whereJsonDTO.endtotaveragePricement;
      }

      if (form.whereJsonDTO.gradeMembership === "") {
        //会员等级
        this.levelUnlimited = true;
        this.gradeMembershipArr = [];
      } else {
        this.levelUnlimited = false;
        this.gradeMembershipArr = form.whereJsonDTO.gradeMembership.split(",");
      }

      this.ruleForm.whereJson.orderTime = form.whereJsonDTO.orderTime; //最后交易时间
      this.ruleForm.whereJson.startorderTime = form.whereJsonDTO.startorderTime;
      this.ruleForm.whereJson.endorderTime = form.whereJsonDTO.endorderTime;
      this.ruleForm.whereJson.area = form.whereJsonDTO.area; //所在地区
      if (form.whereJsonDTO.crowd_portrait_type.length > 0) {
        this.crowd_portrait_typeArr = form.whereJsonDTO.crowd_portrait_type.split(
          ","
        ); //职业
      }
      if (form.whereJsonDTO.cites) {
        this.checkedList = form.whereJsonDTO.cites.split(',')
      } else {
        this.checkedList = [];
      }

      this.ruleForm.id = form.id;
      let arr1 = form.whereJsonDTO.labelIds.split(","); // 标签
      let arr2 = [];
      arr1.forEach((item) => {
        arr2.push(Number(item));
      });

      let selectNewList = [];
      getBuyerLabel().then((res) => {
        res.data.forEach((item, index) => {
          if (arr2.indexOf(item.id) != -1) {
            selectNewList.push(item);
          }
        });
        this.selectIdsArr = selectNewList;
      });
    },

    //查询事件
    queryList() {
      // console.log(this.pageName);
      this.tableLoading = true;

      // return
      getShopBuyerGroup(this.formDataList).then((res) => {
        if (res && res.code == 1) {
          this.tableLoading = false;
          this.tableList = res.data.records;
          console.log(this.tableList);
          this.totalNum = res.data.total;
        }
      });
    },
    //查询我的分组
    handleClick() {
      this.tabActiveIndex = 2;
      this.formDataList.type = 1;
      this.formDataList.current = 1;
      // this.pageName = '客户管理-会员分组-系统分组'

      this.queryList();
    },
    handleClick2() {
      this.tabActiveIndex = 3;
      this.formDataList.type = 0;
      this.formDataList.current = 1;
      // this.pageName = '客户管理-会员分组-我的分组'
      this.queryList();
    },
    handleClick0() {
      this.tabActiveIndex = 1;
      this.formDataList.type = "";
      this.formDataList.current = 1;
      // this.pageName = '客户管理-会员分组-我的分组'
      this.queryList();
    },
    //搜索
    searchContent(form) {
      console.log(form);
      // this.formDataList.size = 10;
      this.formDataList.current = 1;
      this.formDataList.startTime = form.startTime;
      this.formDataList.endTime = form.endTime;
      this.queryList();
    },
    //重置
    resetContent() {
      this.startTime = "";
      this.endTime = "";
      this.formDataList = {
        size: 10,
        current: 1,
      };
      this.queryList();
    },
    //会员营销
    marketNow(ind, tableList, groupName) {
      tableList.forEach((item, index) => {
        console.log(ind);
        if (ind === index) {
          let buyerNum = item.buyerNum;
          if (buyerNum >= 2) {
            let routeUrl = this.$router.resolve({
              path: "/marketing/marketing/member_send",
              query: {
                tabIndex: 2,
                groupName: 1 + ind,
                // groupId: item.id,
                type: this.tabActiveIndex,
                current: this.formDataList.current,
                size: this.formDataList.size,
              },
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.warning(
              "京东官方规定人数少于2无法发送，请增加营销人数~"
            );
          }
        }
      });
    },
    //点击弹出删除框
    handleDelete1(id) {
      this.handleDeleteid = id;
      this.outerVisible = true;
    },
    //关闭删除分组弹框
    closehandleDelete() {
      this.outerVisible = false;
      this.$message.warning("已关闭删除");
    },
    handleDeleteTable() {
      this.outerVisible = false;
      this.handleDelete(this.handleDeleteid);
    },
    //删除分组
    handleDelete(id) {
      // this.$confirm("确定要删除吗?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      deleteBuyerGroupById(id)
        .then((res) => {
          if (res && res.code == 1) {
            this.outerVisible = false;
            this.$message.success("删除成功");
            this.queryList();
          }
          // });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //分页事件
    handleSizeChange(val) {
      this.formDataList.current = 1;
      this.formDataList.size = val;
      this.queryList();
    },
    handleCurrentChange(val) {
      this.formDataList.current = val;
      this.queryList();
    },
    //点击自定义时是否显示
    changeCityShow() {
      this.cityShow = true;
    },
    cityRadioChange(value) {
      this.formDataList.province = value;
      if (value == "") {
        this.checkedList = [];
        this.cityShow = false;
        // this.selectCityNum = 0;
      } else if (value == "JZH") {
        // this.checkedList = "200000,310000,315000,325000,314000,313000,312000,321000,324000,316000,318000,323000,210000,214000,221000,213000,215000,226000,222000,223001,224000,225000,212000,225300,223800".split(
        //   ","
        // ); //江浙沪地区编码前端写死
        // this.cityShow = false;
        // this.selectCityNum = 0;
      } else if (value == "RemoteArea") {
        // this.checkedList = "830000,834000,838000,839000,848000,843000,844000,845350,841000,831100,833400,835000,832000,843300,844100,831300,810000,810600,812200,811300,813000,814000,815000,817000,650000,653100,655000,657000,661400,663000,666100,671000,673100,674100,674400,675000,677000,678000,678400,850000,852000,854000,856000,857000,859000,860000".split(
        //   ","
        // ); //偏远地区编码前端写死
        // this.selectCityNum = 0;
        // this.cityShow = false;
      } else if (value == "Customized") {
        // this.checkedList = [];
        this.cityShow = true;
      }
    },
    //选择标签弹窗
    toAddLabelMoreResult() {
      this.labelState = true;
    },
    transferName4(val) {
      console.log(val);
      this.selectIdsList = val;
      this.labelState = false;
      if (this.labelType == 1 && val.cancel != true) {
        if (this.addResult == true) {
          // 按查询结果打标签
          this.updateLabelByCondition(val.idArr);
        } else {
          // 打标签
          this.batchInsertLabel(2, val.idArr);
        }
        return;
      }
      if (!val.cancel) {
        this.selectIdsArr = val.selectArr;
        this.selectIdsArr2 = val.idArr;
        this.labelIdsArr = val.idArr;
      }
    },
    //删除标签
    deleteLabel(currData) {
      event.stopPropagation();
      const index = this.selectIdsArr.findIndex(
        (item) => item.id === currData.id
      );
      this.selectIdsArr.splice(index, 1); //删除指定的标签

      let aa = [];
      this.selectIdsArr.forEach((item) => {
        aa = aa.concat(item.id);
      });
      this.labelIdsArr = aa;
    },
    switchLevel(type) {
      if (type == "0") {
        this.gradeMembershipArr = [];
      } else if (type == "1") {
        this.levelUnlimited = false;
      }
    },
  },
  computed: {
    pageName() {
      console.log(this.tabActiveIndex);
      // let text = ""
      let index = this.tabActiveIndex;
      // return () => {
      if (index == 1) {
        return "客户管理-会员分组-全部分组";
      }
      if (index == 2) {
        return "客户管理-会员分组-系统分组";
      }
      if (index == 3) {
        return "客户管理-会员分组-我的分组";
      }
      // console.log(text)
      // return text;
      // }
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-input--small .el-input__icon {
  display: none;
}
/deep/ .el-table .el-table__header-wrapper th .cell {
  height: 60px;
  line-height: 50px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  -webkit-font-smoothing: antialiased;
  color: #333333;
  background-color: #fafafa;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 98px;
  height: 32px;
  border-radius: 3px;
  background-color: #fe4d45;
  border: 1px solid #fe4d45;
  color: #fff;
  font-size: 14px;
  transition: all 0.3s ease-in;
}
.titlecolorBox {
  // @media screen and (max-width: 1620px) {
  //   width: 69px;
  // }
  // width: 60px;
  .titlecolor {
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #fe4d45;
    }
  }
  .titlecolor1 {
    margin: 0 10px;
    cursor: pointer;
    color: #7f85e9;
    @media screen and (max-width: 1620px) {
      margin: 0;
    }
    &:hover {
      color: #fe4d45;
    }
  }
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #fe4d45;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.btn:hover {
  background: #fe4d45;
  opacity: 0.9;
}
.merchandise-container {
  box-sizing: border-box;
  padding: 10px 20px 0;
  // height: 946px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-bottom: 33px;
  background-color: #fff;
  .head {
    box-sizing: border-box;
    height: 45px;
    // line-height: 53px;
    padding-top: 10px;
    padding-left: 10px;
    border-bottom: 1px solid #f6f6f6;
    color: #2e3458;
    font-size: 16px;
    font-weight: bold;
  }
  .content {
    box-sizing: border-box;
    padding: 20px 30px;
    // height: 892px;
    .timer {
      display: flex;
      align-items: center;
      margin-bottom: 19px;
      color: #252c38;
      font-size: 14px;
      span {
        margin-right: 8px;
      }
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90px;
        height: 30px;
        margin: 0 12px 0 25px;
        border-radius: 3px;
        background-color: #fe4d45;
        color: #fff;
        font-size: 14px;
        transition: all 0.3s ease-in;
      }
      .btn:hover {
        background: #fe4d45;
        opacity: 0.9;
      }
      .btn1 {
        width: 98px;
        height: 32px;
        border-radius: 3px;
        padding: 5px 12px;
        color: #fe4d45;
        border: 1px solid #fe4d45;
        margin-right: 2px;
        background-color: #fff;
        &:hover {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
        &:active {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
      }
      .btn2 {
        color: #666666;
        background-color: #fff;
        border: 1px solid #dddddd;
      }
      .btn2:hover {
        color: #fe4d45;
        background-color: #fff4f4;
        border: 1px solid #fe4d45;
      }
      // &:active {
      //   background-color: #e63c34;
      // }
      cursor: pointer;
      .search {
        margin-right: 4px;
      }
    }
    .table-wrapper {
      .tabList {
        display: flex;
        box-sizing: border-box;
        height: 36px;
        line-height: 35px;
        // margin-top: 20px;
        color: #666;
        font-size: 14px;
        margin: 20px 0;
        span {
          margin-right: 3px;
          width: 106px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          vertical-align: middle;
          transform: perspective(1px) translateZ(0);
          box-shadow: 0 0 1px rgba(0, 0, 0, 0);
          border-radius: 2px 2px 0px 0px;
          border: 1px solid #dddddd;
          text-align: center;
        }
        .active {
          position: relative;
          transition: all 0.2s;
          color: #fe4d45;
          border-bottom: none;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            top: 0;
            height: 2px;
            background: #fe4d45;
            border-radius: 6px 6px 0px 0px;
          }
        }
        i {
          flex: 1;
          border-bottom: 1px solid #dddddd;
          margin-left: -3px;
        }
      }
      .box {
        display: flex;
        justify-content: space-between;
        width: 100%;
        min-height: 32px;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 2px 5px;
        word-break: break-all;
        ul {
          display: flex;
          flex-wrap: wrap;
          li {
            min-width: 50px;
            min-height: 26px;
            line-height: 26px;
            background-color: #fe4d45;
            color: #ffffff;
            margin-right: 5px;
            border-radius: 3px;
            box-sizing: border-box;
            padding: 0 3px;
            margin-top: 5px;
          }
        }
        .jiantou {
          font-size: 20px;
          margin-top: 4px;
          color: #9f9f9f;
        }
      }
      .btn {
        margin-left: 300px;
      }
    }
  }
}
</style>
